export interface ScheduledCommunicationList {
  content: string
  destination: string
  id: number
  reservation: ScheduledCommunicationReservation
  reservationId: number
  scheduledDatetime: string
  status: ScheduledCommunicationStatus
}

export interface ScheduledCommunicationReservation {
  flightxInProgress: boolean
  fromBarsala: boolean
  home: {
    property: {
      market: {
        timezone: string
      }
    }
  }
  lexit: boolean
  member: {
    fullName: string
    id: number
  }
  professionalHousing: boolean
  standby: boolean
}

export enum ScheduledCommunicationStatus {
  Cancelled = 'Cancelled',
  Delivered = 'Delivered',
  PendingApproval = 'Pending approval',
  PendingDelivery = 'Pending delivery',
  UnableToDeliver = 'Unable to deliver',
}
